import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Receipt } from 'lucide-react';

const SuccessMessage = ({ transaction, getInvoiceId, onViewReceipt }) => {
    const navigate = useNavigate();

    if (!transaction) return null;

    return (
        <Card className="p-6 mb-8 bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800">
            <div className="flex items-start justify-between">
                <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                        <CheckCircle2 className="w-5 h-5 text-green-500" />
                        <h2 className="text-lg font-semibold">Payment Successful!</h2>
                    </div>
                    <p className="text-gray-600 dark:text-gray-300">
                        Thank you for your purchase. {transaction.amount} credits have been added to your account.
                    </p>
                </div>
                <div className="flex gap-3">
                    <Button
                        variant="outline"
                        size="sm"
                        className="flex items-center gap-2"
                        onClick={() => onViewReceipt(transaction)}
                    >
                        <Receipt className="h-4 w-4" />
                        View Receipt
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default SuccessMessage;